export const PAGE_VIEW_EVENT_NAME = "page_view";
type PageViewEvent = {
  event: typeof PAGE_VIEW_EVENT_NAME;
};

export const VIEW_SEARCH_RESULTS_EVENT_NAME = "view_search_results";
type ViewSearchResultsEvent = {
  event: typeof VIEW_SEARCH_RESULTS_EVENT_NAME;
};

export const ECOMMERCE_BEGIN_CHECKOUT_EVENT_NAME = "begin_checkout";
export const ECOMMERCE_SHIPPING_DETAILS_EVENT_NAME = "shipping_details";
export const ECOMMERCE_PAYMENT_DETAILS_EVENT_NAME = "payment_details";
export const ECOMMERCE_CLIENT_INFOS_EVENT_NAME = "client_infos";
export const ECOMMERCE_PURCHASE_EVENT_NAME = "purchase";
export const ecommerceEventAuthorizedNames = [
  ECOMMERCE_BEGIN_CHECKOUT_EVENT_NAME,
  ECOMMERCE_SHIPPING_DETAILS_EVENT_NAME,
  ECOMMERCE_PAYMENT_DETAILS_EVENT_NAME,
  ECOMMERCE_CLIENT_INFOS_EVENT_NAME,
  ECOMMERCE_PURCHASE_EVENT_NAME,
] as const;
export type EcommerceEventName = (typeof ecommerceEventAuthorizedNames)[number];
export type EcommerceEventData = {
  currency?: string;
  value?: number;
  items: [
    {
      item_id: string;
      item_name: string;
      item_category: string;
      grade?: "A" | "B" | "C" | "D" | "E";
    },
  ];
};
type EcommerceEvent = {
  event: EcommerceEventName;
  ecommerce: EcommerceEventData;
};

export type Event = PageViewEvent | ViewSearchResultsEvent | EcommerceEvent;
